import type { ErrorComponentProps } from '@tanstack/react-router';

import { Button, Icon } from '@/components/ui';

export function ErrorComponent({ error, reset }: ErrorComponentProps) {
  return (
    <div
      className="flex h-screen flex-col items-center justify-center gap-4 px-4 text-center"
      role="alert"
    >
      <div className="flex flex-col items-center gap-2">
        <Icon name="alert" size={36} style={{ color: 'var(--red)' }} />
        <h1 style={{ fontFamily: 'var(--font-ui)', fontSize: 18, fontWeight: 600, margin: 0 }}>
          Something went wrong
        </h1>
        <p style={{ maxWidth: 400, fontSize: 13, color: 'var(--text-2)', margin: 0 }}>
          {error.message}
        </p>
      </div>
      <Button variant="secondary" size="sm" onClick={reset}>
        Try again
      </Button>
    </div>
  );
}
